/* global addPlaceholderInputValues, refreshDobDayInput, loadStatesAndProvinces, toggleCheckbox, calculateAge, addOptCheckbox isOverEighteen a*/

SC.checkout_landing = function () {
  var api = {};
  var $dobMonthInput      = $('.global__input-select-dob_group > #frm-dob_month');
  var $dobDayInput        = $('.global__input-select-dob_group > #frm-dob_day');
  var $dobYearInput       = $('.global__input-select-dob_group > #frm-dob_year');
  var $countryInput       = $('.global__input-select-location_group > #frm-country');
  var $stateInput         = $('.global__input-select-location_group > #frm-state');
  var $optMarketingLabel  = $('#optout_marketing-label');
  var $optMarketingSpan   = $('#optout_marketing-span');
  var $optSellingLabel    = $('#opt_selling-label');
  var $optSellingSpan     = $('#opt_selling-span');
  var $formError          = $('.form-error');
  var $modalPasswordReset = $('#modal-password_reset_notification');
  var $modalCloseBtn      = $('#modal-password_reset_notification .button__primary');
  var $modalCloseX        = $('#modal-password_reset_notification .close');

  var init = function () {
    setUserEntryComponents();

    setEvents();
  };

  var components = [];

  var onUserEntryFormSubmit = function (e) {
    var formObj = this;
    var $formEl = formObj.$formEl;
    var $inputEls = formObj.$inputEls;

    formObj.errors = [];

    e.preventDefault();

    $inputEls.each(function (i, el) {
      var $el = $(el).removeClass('field-error');
      var errorMessage = $el.data('nette-rules') ? $el.data('nette-rules')[0].msg : $el.data('error');

      if ($el.attr('required') && !$.trim(el.value)) {
        formObj.errors.push({
          name: 'required field',
          message: errorMessage + ' <span class="visually-hidden">Use your browser\'s modifier key and \'' + $el.attr('accessKey') + '\' to access the field.</span>',
          el: [ $el ]
        });
      }

      if ($el.attr('type') === 'email' && !el.value.match(/^([\w-]+(?:\.[\w-+]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i)) {
        formObj.errors.push({
          name: 'email address',
          message: 'please use a valid email address <span class="visually-hidden">Use your browser\'s modifier key and \'' + $el.attr('accessKey') + '\' to access the field.</span>',
          el: [ $el ]
        });
      }
    });

    validatePassword.apply(formObj);

    // HTML5 validation
    if (formObj.errors.length > 0) {
      confirmation(undefined, formObj.errors[0].message, undefined, 0);

      formObj.errors[0].el.forEach(function (el) {
        el.addClass('field-error');
      });

      return;
    }

    SC.utils.ui.toggleThrobber(true);

    var capturedEmail = SC.analytics.mp.getEmailAttribute();
    $formEl.ajaxSubmit({
      dataType: 'json',
      success: function (data) {
        $formEl.updateCsrfToken();
        var eventData;

        if (data.success) {
          var successRedirectUrl = data.redirect?.url || data.redirect || '/checkout/';
          var branchPromise = null;
          var userEventPromise;
          var emailWasCaptured;

          if (formObj.formType === 'form-signin') {
            /**
             * Branch identity setup and tracking login
             */
            branchPromise = SC.analytics.branch.setIdentity(data.rider.id);

            /**
             * mparticle user identity setup
             */
            SC.analytics.mp.userEvent('remove');
            userEventPromise = SC.analytics.mp.userEvent('setup', data.rider.id.toString());

            userEventPromise.then(function () {
              SC.analytics.mp.userEvent('attribute', data.rider.first_name.toString(), 'first_name');

              /**
               * mparticle sendEvent - log in successful
               */
              eventData = {
                'Response': 'Success',
                'Location': 'Shop'
              };
              SC.analytics.mp.sendEvent('Click Log In CTA', 'navigation', eventData, 'Shop');
            });

            // Redirect after mParticle setup
            branchPromise.always(function () {
              userEventPromise.always(function () {
                window.location.replace(successRedirectUrl);
              });
            });

            return;
          } else if (formObj.formType === 'form-signup') {
            /**
                         * Branch signup event tracking
                         */
            branchPromise = SC.analytics.branch.setIdentity(data.rider.id);

            emailWasCaptured = data.rider && capturedEmail && data.rider.email === capturedEmail;

            /**
                         * google Adwords Conversion - Account creation
                         */
            SC.analytics.ga.trackConversion(872817258, 'en', '3', 'ffffff', 'KjFLCKnsrGoQ6sSYoAM', false, '', '');

            /**
                         * mParticle User Identity - setup user
                         */
            // If user being registered is NOT the same that was captured previously
            if (!emailWasCaptured) {
              SC.analytics.mp.userEvent('remove');
            }

            userEventPromise = SC.analytics.mp.userEvent('setup', data.rider_id.toString());

            userEventPromise.then(function () {
              SC.analytics.mp.userEvent('attribute', data.rider.first_name.toString(), 'first_name');
              SC.analytics.mp.userEvent('attribute', 1, 'has_account');

              /**
               * mparticle sendEvent - sign up successful
               */
              eventData = {
                'Response': 'Success',
                'Location': 'Shop',
                'Step': null
              };
              SC.analytics.mp.sendEvent('Account Creation Response', 'navigation', eventData, 'Shop');

              if (emailWasCaptured) {
                SC.analytics.mp.sendEvent('Create Account Since Email Capture', 'navigation');
              }
            });

            /**
             * Old GA sendEvent - account creation successful.
             * Deprecated: Will be removed as some point.
             */
            SC.analytics.ga.sendEvent('user', 'sign_up');

            // Redirect after branch & mParticle setup
            branchPromise.always(function () {
              userEventPromise.always(function () {
                window.location.replace(successRedirectUrl);
              });
            });

            return;
          }

          // This should happen regardless if we have a formType
          window.location.replace(successRedirectUrl);
          return;
        } else if (data.redirect && data.redirect.error) {
          // currently used for underage riders

          /**
           * mParticle sendEvent - Account Creation Response - Underage error
           * Sends mParticle event with a label for GA Event.
           */
          eventData = {
            'Response': 'User is underage error (' + data.redirect.error + ')',
            'Location': 'Shop',
            'Step': null
          };
          SC.analytics.mp.sendEvent('Account Creation Response', 'navigation', eventData, 'Shop');

          window.location.replace(data.redirect.url);
          return;
        }

        if (formObj.formType === 'form-signup') {
          /**
           * mParticle sendEvent - Account Creation Response - Invalid
           * Sends mParticle event with a label for GA Event.
           */
          eventData = {
            'Response': 'Invalid email, password, First Name, Last Name or Phone Number, Emergency Contact Name, Emergency Phone Number or Terms & Conditions',
            'Location': 'Shop',
            'Step': null
          };
          SC.analytics.mp.sendEvent('Account Creation Response', 'navigation', eventData, 'Shop');
        } else if (formObj.formType === 'form-signin') {
          /**
           * mParticle sendEvent - Click Log In CTA - Invalid
           * Sends mParticle event with a label for GA Event.
           */
          eventData = {
            'Response': 'Invalid email or password',
            'Location': 'Shop'
          };
          SC.analytics.mp.sendEvent('Click Log In CTA', 'navigation', eventData, 'Shop');
        }

        // reset inputs
        $inputEls.removeClass('invalid');

        // check for any field errors
        $formEl.clearFormErrors();
        if (data.fieldErrors) {
          $formEl.fieldErrors(data.fieldErrors);
        } else {
          var message = data.message ? data.message : genericErrorMessage;

          $formEl.find('input.medium').addClass('invalid');
          confirmation(undefined, message);
        }

        SC.utils.ui.toggleThrobber(false);
      },
      error: function (jqXHR, status, errorThrown) {
        var eventData;
        if (formObj.formType === 'form-signup') {
          eventData = {
            'Response': 'Server Error - status: ' + status + ', error: ' + errorThrown,
            'Location': 'Shop',
            'Step': null
          };
          SC.analytics.mp.sendEvent('Account Creation Response', 'navigation', eventData, 'Shop');
        }

        if (formObj.formType === 'form-signin') {
          if (window.grecaptcha && typeof window.grecaptcha.reset === 'function') {
            window.grecaptcha.reset();
          }

          var data = jqXHR && jqXHR.responseJSON;
          if (data.tooManyAttemps) {
            $('.login-component-container .recaptcha-message').addClass('too-many-attempts');
          }

          if (jqXHR.responseJSON.reason && jqXHR.responseJSON.reason === 'password_strength') {
            $modalPasswordReset.show();
          } else {
            $formEl.clearFormErrors();
            if (data.fieldErrors && data.fieldErrors.length) {
              $formEl.fieldErrors(data.fieldErrors);
            } else {
              var message = data.message ? data.message : genericErrorMessage;

              $formEl.find('input.medium').addClass('invalid');
              confirmation(undefined, message);
            }

            eventData = {
              'Response': 'Server Error - status: ' + status + ', error: ' + errorThrown,
              'Location': 'Shop'
            };
            SC.analytics.mp.sendEvent('Click Log In CTA', 'navigation', eventData, 'Shop');
          }
        }

        $formEl.updateCsrfToken();
        SC.utils.ui.toggleThrobber(false);
      }
    });
  };

  var setEvents = function () {
    /**
     * Old GA SendEvent - Shop - Checkout Landing page view
     * Deprecated: Will be removed soon.
     * @returns {void}
     */
    window.onload = function () {
      SC.analytics.ga.sendEvent('shop', 'checkout', 'checkout_landing');
    };
  };

  var setUserEntryComponents = function () {
    // aggregate all expanding forms into an array
    // cache jQuery elements
    $('.sc-login-component').each(function (i, el) {
      var $el = $(el);
      var component = {
        type: 'sc-user-entry',
        title: $el.find('h3').text(),
        $el: $el,
        formObjs: []
      };

      setFormObjs(component);

      if (component.$el.find('.form-expand')) {
        setFormExpand(component);
      }

      components.push(component);
    });
  };

  var setFormExpand = function (component) {
    component.$el.find('.form-expand').each(function (i, el) {
      var $el = $(el);

      // bind events
      $el.find('.form-expand-button').on('click', function (e) {
        e.preventDefault();
        var $btn = $(this);
        $el.toggleClass('show-form');
        if ($btn.hasClass('expand-create-account-form')) {
          var eventData = {
            'Location': 'Shop',
            'Context': null
          };
          SC.analytics.mp.sendEvent('Click to Sign Up', 'navigation', eventData, 'Shop');
        }
      });
    });
  };

  var setFormObjs = function (component) {
    component.$el.find('form').each(function (i, el) {
      var $form = $(el);
      var formObj = {
        formType: $form.attr('class'),
        $formEl: $form,
        $inputEls: $form.find('input'),
        $inputPassword: $form.find('input[name="password"]'),
        $inputConfirmPassword: $form.find('input[name="confirmpassword"]'),
        errors: {}
      };

      // customize form when Nette framework loads
      $form.on('netteloaded onnetteloaded', function () {
        // $form[0].noValidate = false;
      });

      // bind events
      $form.on('click', '.submit', onUserEntryFormSubmit.bind(formObj));

      component.formObjs.push(formObj);
    });
  };


  refreshDobDayInput();
  loadStatesAndProvinces();
  addOptCheckbox();
  addPlaceholderInputValues();

  $dobMonthInput.change(function () {
    refreshDobDayInput();
    checkAgeEligibility();
    addOptCheckbox();
  });

  $dobDayInput.change(function () {
    checkAgeEligibility();
    addOptCheckbox();
  });

  $dobYearInput.change(function () {
    checkAgeEligibility();
    refreshDobDayInput();
    addOptCheckbox();
  });

  $countryInput.change(function () {
    loadStatesAndProvinces();
    addOptCheckbox();
  });

  $stateInput.change(function () {
    addOptCheckbox();
  });

  $optSellingLabel.click(function () {
    toggleCheckbox('opt_in_selling');
  });

  $optSellingSpan.click(function () {
    toggleCheckbox('opt_in_selling');
  });

  $optMarketingLabel.click(function () {
    toggleCheckbox('opt_out_marketing');
  });

  $optMarketingSpan.click(function () {
    toggleCheckbox('opt_out_marketing');
  });

  $modalCloseBtn.click(function () {
    $modalPasswordReset.hide();
  });

  $modalCloseX.click(function () {
    $modalPasswordReset.hide();
  });

  init();

  function validatePassword() {
    var $inputPassword = this.$inputPassword;
    var $inputConfirmPassword = this.$inputConfirmPassword;

    // check for confirmed password match
    if ($inputPassword.length === 0 || $inputConfirmPassword.length === 0) {
      return;
    }

    if ($inputPassword.val() !== $inputConfirmPassword.val()) {
      this.errors.push({
        name: 'confirmPassword',
        message: 'Passwords don\'t match',
        el: [ $inputPassword, $inputConfirmPassword ]
      });
      return;
    }
  }


  function checkAgeEligibility() {
    if (!isOverEighteen()) {
      $formError.text('If you are under 18, registration must be completed in person, at one of our studios, ' +
        'accompanied by a parent or guardian who must sign a Minor New Rider Waiver Form for you. After this is complete, ' +
        'you may sign up for SoulCycle classes online. Riders must be at least at least 12 years of age, meet the minimum height requirement of 4\'11"');
    } else {
      $formError.text('');
    }
  }

  return api;
};
